export default __webpack_public_path__ + "static/media/logo-white.6b6c25c1.png";